import {
  ChannelType,
  SupportingActorSlackChannel,
  SupportingActorType
} from '@dadohr/shared/domainTypes/experience';
import { FormHelperText } from '@material-ui/core';
import { CustomInputLabel } from '../../../../../../../components/CustomInputLabel';
import { HalfWidthField } from '../../ActorDialogParts';
import { useUnsafeTranslation } from '../../../../../../../i18next';
import { FlexContainerVertical } from '../../../../../../../layout/Flex';
import { ExistingChannelSelector } from '../../../../../components/Builders/AutomationBuilder/ActionSettings/Slack';
import type {
  ActorTypeFieldsProps,
  ActorTypeForm,
  ChannelActorState
} from '..';

const ChannelActorFields = ({
  state,
  onChange,
  showValidation,
  orgId
}: ActorTypeFieldsProps<ChannelActorState>) => {
  const { t } = useUnsafeTranslation();
  return (
    <HalfWidthField>
      <CustomInputLabel fullWidth label={t('Channel')}>
        <FlexContainerVertical fullWidth spacing={0}>
          <ExistingChannelSelector
            orgId={orgId}
            value={{
              id: state.channelId,
              name: state.channelName,
              isPrivate: false
            }}
            onChange={(nextChannel) =>
              onChange({
                ...state,
                channelId: nextChannel.id,
                channelName: nextChannel.name
              })
            }
            label=""
          />
          {showValidation && !state.channelId && (
            <FormHelperText error>
              {t('Please select a Slack channel')}
            </FormHelperText>
          )}
        </FlexContainerVertical>
      </CustomInputLabel>
    </HalfWidthField>
  );
};

/** "Slack channel": messages go to a channel instead of a person. */
export const channelActorType: ActorTypeForm<ChannelActorState> = {
  option: SupportingActorType.CHANNEL,
  label: (t) => t(`Slack channel`),
  matches: (actor) => actor.type === SupportingActorType.CHANNEL,
  fromActor: (actor) => {
    const a = actor as SupportingActorSlackChannel;
    return {
      name: a.name,
      type: SupportingActorType.CHANNEL,
      channeltype: ChannelType.SLACK,
      color: a.color,
      channelId: a.channelId,
      channelName: a.channelName,
      ignoreWhenMissing: !!a.ignoreWhenMissing
    };
  },
  create: (base) => ({
    name: base.name,
    type: SupportingActorType.CHANNEL,
    channeltype: ChannelType.SLACK,
    color: base.color,
    channelId: '',
    channelName: '',
    ignoreWhenMissing: true
  }),
  isComplete: (state) => !!state.channelId,
  toActor: (state, key) => ({
    type: SupportingActorType.CHANNEL,
    channeltype: ChannelType.SLACK,
    channelId: state.channelId,
    name: state.name,
    key,
    color: state.color,
    ignoreWhenMissing: true,
    channelName: state.channelName
  }),
  Fields: ChannelActorFields
};
